import request from '@/utils/request'

// 获取招聘列表
export function fetchList(data) {
  return request({
    url: '/recruitment/v1/listRecruitment',
    data,
  })
}
// 获取招聘数量
export function listNum() {
  return request({
    url: '/recruitment/v1/countRecruitment',
  })
}
// 获取招聘详情
export function fetchRecruit(id) {
  return request({
    url: '/recruitment/v1/getDetailByKey',
    params: { id },
  })
}
